module.exports = __webpack_public_path__ + "static/media/g-3-b.f37f8161.jpg";